<!--<div class="float-right d-none d-sm-block"><b>Version</b> {{ appVersion }}</div>-->
<strong>
 <small class="text-muted">
      Designed & Developed by
      <a href="https://cktechsoln.in" target="_blank" class="text-decoration-none fw-semibold">
         CKTech Solution Pvt Ltd
      </a>
      © {{ currentYear | date: 'yyyy' }}
    </small>
</strong>
<span> All rights reserved.</span>
